import { render, staticRenderFns } from "./EcoBlock.vue?vue&type=template&id=4463f08a&"
import script from "./EcoBlock.vue?vue&type=script&lang=js&"
export * from "./EcoBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports